import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "../../src/App.css";
import "../../src/index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUsersGear,
  faUserTie,
  faBalanceScale,
  faMoneyCheckAlt,
  faTags,
  faConciergeBell,
  faUserFriends,
  faWallet,
  faFileInvoiceDollar,
  faReceipt,
  faChartLine,
  faCashRegister,
  faFileAlt,
  faSackDollar,
  faSignOutAlt,
  faGear,
  faChevronUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import Can from "./Can";
import { useAuth } from "../context/AuthContext";
import defaultLogo from "../default-logo.jpg";

// import {Logo as React}

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [subscriptionMessage, setSubscriptionMessage] = useState("");
  const [openSection, setOpenSection] = useState(null);
  useEffect(() => {
    const subscription = user?.data?.lastSubscription;
    if (subscription && subscription.to) {
      // const today = new Date();
      // const endDate = new Date(subscription.to);
      // const diffTime = endDate - today;
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      // const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
      // const diffMinutes = Math.ceil(diffTime / (1000 * 60));
      // console.log("end", endDate, "today", today, "days", diffDays, diffHours);

      // if (diffDays > 0 && diffDays <= 10) {
      //     setSubscriptionMessage(
      //         `الاشتراك سينتهي بعد ${diffDays } يوم`
      //     );
      // }
      const now = new Date();
      const endDate = new Date(subscription.to); // تاريخ انتهاء الاشتراك

      const diffMs = endDate - now;

      if (diffMs > 0) {
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor(
          (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const diffMinutes = Math.floor(
          (diffMs % (1000 * 60 * 60)) / (1000 * 60)
        );

        if (diffDays > 1) {
          setSubscriptionMessage(
            ` الاشتراك سينتهي بعد ${diffDays} يوم : ${diffHours} ساعه : ${diffMinutes} دقيقة`
          );
        } else {
          setSubscriptionMessage(
            `الاشتراك سينتهي بعد ${diffHours} ساعة و ${diffMinutes} دقيقة`
          );
        }
      } else {
        setSubscriptionMessage("انتهى الاشتراك");
      }
    }
  }, [user]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    localStorage.removeItem("userName");
    navigate("/login", { replace: true });
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // console.log(user?.data);

  return (
    <>
      <nav className="navbar no-print">
        <div className="navbar-container">
          <button className="menu-btn" onClick={toggleSidebar}>
            ☰
          </button>
          {subscriptionMessage && (
            <div
              className="alert text-white mb-0 p-2"
              style={{
                background: "linear-gradient(135deg, #6a11cb 0%, #8e2de2 100%)",
                borderRadius: "5px",
                border: "none",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                fontWeight: "500",
              }}
            >
              {subscriptionMessage}
            </div>
          )}
          <Link to="/dashboard">
            <img
              src={user?.data?.setting?.company_logo || defaultLogo}
              alt="Company Logo"
              className="navbar-logo"
            />
          </Link>
        </div>
      </nav>

      {isOpen && <div className="overlay" onClick={closeSidebar}></div>}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={closeSidebar}>
          ×
        </button>
        <ul>
          <li
            className="section-title"
            onClick={() => toggleSection("operations")}
          >
            العمليات{" "}
            <FontAwesomeIcon
              icon={openSection === "operations" ? faChevronUp : faChevronDown}
            />
          </li>
          {openSection === "operations" && (
            <>
              <Can permission="category_show">
                <li>
                  <NavLink
                    to="/categories"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faTags} /> التصنيفات
                  </NavLink>
                </li>
              </Can>
              <Can permission="service_show">
                <li>
                  <NavLink
                    to="/services"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faConciergeBell} /> الخدمات
                  </NavLink>
                </li>
              </Can>
              {/* ناقص permission */}
              <Can permission="service_show">
                <li>
                  <NavLink
                    to="/employeewithdraws"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faConciergeBell} /> مسحوبات الموظفين
                  </NavLink>
                </li>
              </Can>
              {/* ناقص permission */}
              <Can permission="service_show">
                <li>
                  <NavLink
                    to="/licences"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faConciergeBell} /> التراخيص
                  </NavLink>
                </li>
              </Can>
              <Can permission="customer_show">
                <li>
                  <NavLink
                    to="/customers"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faUserFriends} /> العملاء
                  </NavLink>
                </li>
              </Can>
              <Can permission="expense_show">
                <li>
                  <NavLink
                    to="/expenses"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faWallet} /> المصاريف
                  </NavLink>
                </li>
              </Can>
              <Can permission="invoice_show">
                <li>
                  <NavLink
                    to="/invoices"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faFileInvoiceDollar} /> الفواتير
                  </NavLink>
                </li>
              </Can>
              <Can permission="money_invoice_show">
                <li>
                  <NavLink
                    to="/money-invoices"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faReceipt} /> السندات
                  </NavLink>
                </li>
              </Can>
              <Can permission="owner_withdrawl_show">
                <li>
                  <NavLink
                    to="/owner-withdrawl"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faSackDollar} /> مسحوبات المالك
                  </NavLink>
                </li>
              </Can>
              <Can permission="cash_transfer_show">
                <li>
                  <NavLink
                    to="/cash-transfer"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faSackDollar} /> تحويلات نقدية
                  </NavLink>
                </li>
              </Can>
            </>
          )}

          <li className="section-title" onClick={() => toggleSection("hr")}>
            الموارد البشرية{" "}
            <FontAwesomeIcon
              icon={openSection === "hr" ? faChevronUp : faChevronDown}
            />
          </li>
          {openSection === "hr" && (
            <>
              <Can permission="employee_show">
                <li>
                  <NavLink
                    to="/employees"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faUserTie} /> الموظفون
                  </NavLink>
                </li>
              </Can>
              <Can permission="empAdjustment_show">
                <li>
                  <NavLink
                    to="/discount-rewards"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faBalanceScale} /> العمولة والخصم
                  </NavLink>
                </li>
              </Can>
              <Can permission="salary_show">
                <li>
                  <NavLink
                    to="/salary"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faMoneyCheckAlt} /> الرواتب
                  </NavLink>
                </li>
              </Can>
            </>
          )}

          <li
            className="section-title"
            onClick={() => toggleSection("reports")}
          >
            التقارير{" "}
            <FontAwesomeIcon
              icon={openSection === "reports" ? faChevronUp : faChevronDown}
            />
          </li>
          {openSection === "reports" && (
            <>
              <Can permission="income_statement_show">
                <li>
                  <NavLink
                    to="/income-statement"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faChartLine} /> قائمة الدخل
                  </NavLink>
                </li>
              </Can>
              <Can permission="cash_report_show">
                <li>
                  <NavLink
                    to="/cash"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faCashRegister} /> تقرير الخزنة
                  </NavLink>
                </li>
              </Can>
              <Can permission="account_statement_show">
                <li>
                  <NavLink
                    to="/account-statement"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faFileAlt} /> كشف الحسابات
                  </NavLink>
                </li>
              </Can>
              <Can permission="service_show">
                <li>
                  <NavLink
                    to="/services-expenses"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faFileAlt} /> مصروفات الخدمات
                  </NavLink>
                </li>
              </Can>

              <Can permission="invoice_taxReport">
                <li>
                  <NavLink
                    to="/taxes-report"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faSackDollar} /> مستحقات الضرائب
                  </NavLink>
                </li>
              </Can>
            </>
          )}

          <li className="section-title" onClick={() => toggleSection("system")}>
            النظام{" "}
            <FontAwesomeIcon
              icon={openSection === "system" ? faChevronUp : faChevronDown}
            />
          </li>
          {openSection === "system" && (
            <>
              {/* <li>
                <NavLink
                  to="/"
                  onClick={closeSidebar}
                  className={({ isActive }) => (isActive ? "active" : "")}>
                  <FontAwesomeIcon icon={faHome} /> الرئيسية
                </NavLink>
              </li> */}

              <Can permission="sub_user_show">
                <li>
                  <NavLink
                    to="/sub-users"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faUsersGear} /> المستخدمون
                  </NavLink>
                </li>
              </Can>
              <Can permission="setting_show">
                <li>
                  <NavLink
                    to="/settings"
                    onClick={closeSidebar}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon icon={faGear} /> الإعدادات
                  </NavLink>
                </li>
              </Can>
            </>
          )}
          <hr />
          <button onClick={handleLogout} className="logout-btn">
            <FontAwesomeIcon icon={faSignOutAlt} /> تسجيل الخروج
          </button>
        </ul>
      </div>
    </>
  );
}

export default Navbar;
